import {Component, Inject, OnInit,Input} from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {MenuController, ModalController, NavParams} from "@ionic/angular";
import {APP_CONFIG, AppConfig} from "../../../app.config";
import { CrudService } from '../../admin/services/crud/crud.service';
import {ChooseDoctorListModalComponent} from "../choose-doctor-list-modal/choose-doctor-list-modal.component";

@Component({
  selector: 'app-choose-doctor',
  templateUrl: './choose-doctor.component.html',
  styleUrls: ['./choose-doctor.component.scss'],
})
export class ChooseDoctorComponent implements OnInit {
  titles = [] as {title: string, ref: string}[];

  conversationType:string;
  constructor(private menu: MenuController,private modalController: ModalController, private firestore: AngularFirestore, private navParam: NavParams) {
    

  }

  ngOnInit() {
    this.conversationType = this.navParam.get('conversationType');
    console.log("deger: ", this.conversationType);
    
    this.firestore.collectionGroup('branches').get().toPromise().then(res => {
      if(res.docs && res.docs.length > 0) {
        res.docs.forEach((item) => {
          
          this.titles.push({title: item.data().title, ref: item.ref.path});
        })
      }
    }).catch(err => {
      console.log(err);
    });
  }

  dismiss(){
    this.modalController.dismiss();
  }

  doctorslist(id:string){
    this.modalController.create({component:ChooseDoctorListModalComponent,id:"ChooseDoctorList",componentProps: { 'conversationType': this.conversationType, 'branchRef': id } }).then((modalElement)=>
        {
          modalElement.present();
        }
    )
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }
}
